module.exports = __webpack_public_path__ + "img/wallpaper-name.460b8352.png";